var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import GeneralTab from '../components/generalTab';
import AccountPostingTab from '../components/accountPostingTab';
import { Download } from '@mui/icons-material';
import AdditionalInfoTab from '../components/additionalInfoTab';
import { PrintIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import { ShareLineSvgIcon } from '../../../assets/customIcons';
import { Box, Chip, Stack, Typography, useMediaQuery } from '@mui/material';
import { ReactComponent as LinkSvg } from '../../../assets/images/linkIcon.svg';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { CSRSaveSuccessfullPopUp } from '../components/CSRSaveSuccessfullPopUp';
import { CSRPaymentReturnPopUp } from '../components/CSRPaymentReturnPopUp';
import { CSRDiscardPopup } from '../components/CSRDiscardPopUp';
import ContractDetails from '../components/contractDetails';
import { ReactComponent as RightArrow } from '../../../assets/images/chevron-right.svg';
import { ReturnSummaryPopup } from '../components/returnSummaryPopUp';
var ContractSalesReturnCreate = function () {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var handleBack = function () {
        navigate('/contractSaleReturn');
    };
    var handlePaymentPopUp = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('Demo Test');
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Dialog',
                            Component: CSRPaymentReturnPopUp,
                            componentProps: {
                                onClose: function () { }
                            },
                            containerProps: {
                                fullWidth: true,
                                maxWidth: 'xs'
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDiscardPopUp = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('Demo Test');
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Dialog',
                            Component: CSRDiscardPopup,
                            componentProps: {
                                onClose: function () { }
                            },
                            containerProps: {
                                fullWidth: true,
                                maxWidth: 'xs'
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveSuccessfullPopUp = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('Demo Test');
                    return [4 /*yield*/, dispatch(showSurface({
                            type: 'Dialog',
                            Component: CSRSaveSuccessfullPopUp,
                            componentProps: {
                                onClose: function () { }
                            },
                            containerProps: {
                                fullWidth: true,
                                maxWidth: 'xs'
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            paddingInline: '24px',
            m: 0,
            bgcolor: "secondary.50",
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    xs: 12,
                    sm: 8,
                    md: 6,
                    alignItems: 'center',
                    gap: '16px',
                    bgcolor: "secondary.50",
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: "secondary.600"
                            },
                            onClick: handleBack,
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: true,
                            alignItems: 'center',
                            sx: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'start'
                                }
                            },
                            gap: '12px',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: 'New contract sale return',
                                    fontWeight: 'strong',
                                    fontSize: 'xxl',
                                    columnSize: 0,
                                    sx: {
                                        textWrap: 'nowrap'
                                    }
                                }]
                        }
                        // {
                        //     type: FormItemTypes.Typography,
                        //     name: '',
                        //     value: 'DOC DATE : 17 Oct, 2090',
                        //     columnSize: 0,
                        //     sx: {
                        //         textWrap: 'nowrap'
                        //     }
                        // },
                        // {
                        //     type: FormItemTypes.Icon,
                        //     name: '',
                        //     value: null,
                        //     columnSize: 0,
                        //     sx: {
                        //         textWrap: 'nowrap'
                        //     },
                        //     children: <EditIcon height={'18px'} width={'18px'} color='secondary600' />,
                        // },
                    ]
                }]
        }, !isMobile ? {
            type: FormItemTypes.Box,
            name: 'headerLabels',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: 'end',
            display: 'flex',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: IS_DESKTOP ? 'Quick links' : undefined,
                    columnSize: 0,
                    sx: {
                        bgcolor: 'transparent',
                        fontWeight: 'medium'
                    },
                    startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null),
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            dispatch(showSurface({
                                type: 'Drawer',
                                Component: ContractDetails,
                                containerProps: {
                                    PaperProps: {
                                        sx: {
                                            width: {
                                                xs: '100%',
                                                sm: '350px'
                                            }
                                        }
                                    },
                                    anchor: isMobile ? 'bottom' : 'right'
                                },
                                componentProps: {
                                    onClose: function () { }
                                }
                            }));
                            return [2 /*return*/];
                        });
                    }); }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(Download, null),
                    columnSize: 0,
                    variant: 'outlined',
                    sx: {
                        padding: '8px'
                    },
                    disabled: true
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    disabled: true,
                    sx: {
                        padding: '8px'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                    columnSize: 0,
                    variant: 'outlined',
                    sx: {
                        padding: '8px'
                    },
                    onClick: function () { return handleSaveSuccessfullPopUp(); }
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    variant: 'fullWidth',
                    orientation: 'vertical',
                    columnSize: 0
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Discard',
                    columnSize: 0,
                    color: 'secondary',
                    onClick: function () { return handleDiscardPopUp(); }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Save',
                    variant: 'contained',
                    children: 'Save',
                    color: 'primary',
                    columnSize: 0,
                    onClick: function () { return handlePaymentPopUp(); }
                }]
        } : null, {
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            columnSize: 12,
            valueExpr: 'id',
            displayExpr: 'Name',
            tabs: [{
                    id: '01',
                    // Name: 'General Tab',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "General"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "0",
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    element: GeneralTab
                }, {
                    id: '02',
                    // Name: 'Account Posting',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Account Posting"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "0",
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    element: AccountPostingTab
                }, {
                    id: '03',
                    // Name: 'Additional info',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Additional info"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "0",
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    element: AdditionalInfoTab
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'end',
            padding: '20px 24px',
            borderTop: '1px solid',
            borderColor: '#DEE4EB',
            position: 'sticky',
            bottom: 0,
            zIndex: 10,
            height: '84px',
            bgcolor: 'secondary.50',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    fullWidth: true,
                    color: 'secondary',
                    sx: {
                        bgcolor: 'white'
                    },
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    startIcon: /*#__PURE__*/ React.createElement(RightArrow, {
                        color: "text.secondary",
                        height: 20,
                        width: 20
                    }),
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Button,
                        children: /*#__PURE__*/ React.createElement(Stack, {
                            width: '100%',
                            justifyContent: 'space-between',
                            direction: 'row',
                            color: '#1B1D21'
                        }, " ", /*#__PURE__*/ React.createElement(Typography, {
                            fontWeight: 'strong'
                        }, "Total amount"), /*#__PURE__*/ React.createElement(Typography, {
                            fontWeight: 'strong'
                        }, "\u20B9 5,963.00"))
                    }); },
                    onClick: function (e, formValues) { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        Component: ReturnSummaryPopup,
                                        componentProps: {
                                            width: e === null || e === void 0 ? void 0 : e.currentTarget.clientWidth,
                                            contractDetails: formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails
                                        },
                                        containerProps: {
                                            anchorEl: e === null || e === void 0 ? void 0 : e.currentTarget.parentElement,
                                            sx: {
                                                '& .MuiPaper-root': {
                                                    borderRadius: '8px',
                                                    width: e === null || e === void 0 ? void 0 : e.currentTarget.clientWidth
                                                }
                                            },
                                            anchorOrigin: {
                                                vertical: 'top',
                                                horizontal: 'right'
                                            },
                                            transformOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'right'
                                            }
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }]
        }, isMobile ? {
            type: FormItemTypes.ContainerItem,
            // name: '',
            // columnSize: 12,
            // width: { xs: '100%', sm: '600px' },
            // justifyContent: 'space-between',
            // position: 'fixed',
            // bottom: 0,
            // right: 0,
            // spacing: 0,
            // p: '16px 24px 24px 24px!important',
            // columnGap: 2,
            // bgcolor: 'white',
            // borderTop: `1px solid ${faintGray}`,
            name: '',
            columnSize: 12,
            spacing: 0,
            justifyContent: 'end',
            padding: '20px 24px',
            borderTop: '1px solid',
            borderColor: '#DEE4EB',
            position: 'sticky',
            bottom: 0,
            zIndex: 10,
            height: '84px',
            bgcolor: 'secondary.50',
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'text',
                    children: 'Discard',
                    columnSize: 0,
                    sx: {
                        color: 'secondary.600'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'contained',
                    children: 'Settle JC',
                    columnSize: 0
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    }));
};
export default ContractSalesReturnCreate;
